var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BuyList',{attrs:{"items":_vm.items.filter(item=> item.Factor_Buy_State===1 && item.Buy_State===1 && item.Recipt_Num && item.Recipt_State===1),"title":"لیست فاکتورهای خرید","read-only":true,"no-price":false,"no-order-info":false,"compact-view":_vm.$q.screen.lt.md,"is-dialog":false,"is-searching":true,"filter":_vm.searchKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }